export const startToCurrentPage = (start, length) => {
    return Math.ceil((start + 1) / length);
}

export const currentPageToStart = (currentPage, length) => {
    let start = 0;

    if (currentPage > 1) {
        start = (currentPage - 1) * length;
    }

    return start;
}

export const getTotalPages = (totalRecords, pageSize) => {
    return Math.ceil(totalRecords / pageSize);
}